// src/pages/NotFound.jsx
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";

export default function NotFound() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/");
    }, 7000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <section className="min-h-[80vh] flex items-center justify-center bg-white px-4">
      <div className="max-w-xl text-center">
        <img
          src={`${process.env.PUBLIC_URL}/theseus.png`}
          alt="ΘΗΣΕΑΣ"
          className="mx-auto h-16 mb-6"
        />

        <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900">
          Η σελίδα δεν βρέθηκε
        </h1>

        <p className="mt-3 text-gray-600 text-lg">
          Η διεύθυνση που ζητήσατε δεν υπάρχει ή έχει μετακινηθεί.
        </p>

        <p className="mt-4 text-sm text-gray-500">
          Θα μεταφερθείτε αυτόματα στην αρχική σελίδα σε 7 δευτερόλεπτα.
        </p>

        <div className="mt-6 flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="rounded-xl bg-blue-600 px-6 py-3 text-white font-semibold hover:bg-blue-700 transition"
          >
            Επιστροφή στην Αρχική
          </Link>

          <Link
            to="/contact"
            className="rounded-xl border border-gray-300 px-6 py-3 font-semibold text-gray-800 hover:bg-gray-50 transition"
          >
            Επικοινωνία
          </Link>
        </div>

        <div className="mt-6 text-sm text-gray-600">
          <div>
            Τηλ: <span className="font-semibold">2510 600 205-07</span>
          </div>
          <div>
            Email: <span className="font-semibold">info@theseus.edu.gr</span>
          </div>
        </div>
      </div>
    </section>
  );
}
